module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-wrapper",
    style: ({
      'height': this.height
    })
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-item"
  }, [_c('div', {
    staticClass: "animated-background"
  }, [_c('div', {
    staticClass: "background-masker header-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker header-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker header-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker header-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker subheader-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker subheader-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker subheader-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-first-end"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-second-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-second-end"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-third-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-third-end"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-365373f8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Tombstone.vue
// module id = 1389
// module chunks = 9